import React, { useEffect, useState } from "react";
import Header from "../../../../layout/header";
import BottomMenu from "../../../../layout/bottomMenu";
import "../../../../Dashboard/Dashboard.css";
import "../../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import Loader from "../../../../../Loader/Loader";
import DashboardMenu from "../../../../layout/dashboardMenu";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FileUpload from "../../../../FileUploads/FileUpload";
import "./raise_payment.css";

const RaisePaymentV2 = ({
  match,
  history,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  bankListResponse = [],
  bankListRequest,
  loanUndertakingRequest,
  loanAccountRequest,
  loanPaymentRaiseRequest,
  loanAccountResponse = [],
  loanUndertakingResponse = [],
  loanPaymentRaiseResponse = [],
  loanTranchesRequest,
  loanTranchesResponse = [],
  loanPaymentRaiseUpdateRequest,
  loanApplicationUpdateResponse = [],
  loanApplicationByIdRequest,
  ucdCaseByIdResponse = [],
  loanApprovalRequestRequest,
  loanApprovalRequestResponse,
  loanPaymentRaiseUpdateResponse = [],
  newBankDetailsRequest,
  newBankDetailsResponse = [],
  foreClosureAddAccountResponse = [],
  foreClosureAddAccountRequest,
}) => {
  const [inputList, setInputList] = useState([
    {
      payment_details: {
        existing_loan: "",
        for_closure_amount: "",
        // fc_closure_amount_proof: '',
        prev_loan_closure: "",
        mode_of_payment: "",
        loan_closure_payment_proof: "",
      },
      dealer_details: {
        account_number: "",
        bank_name: "",
        ifsc_code: "",
        branch_name: "",
      },
      hold_back_Details: {
        amount_approval_proof: "",
        amount: "",
        account_id: "",
        mode_of_payment: "",
        remark: "",
        status: "",
      },
      undertaking: {
        undertaking: "",
      },
    },
  ]);

  const [isLoading, setIsLoading] = useState(false);
  const [stage, setStage] = useState(1);
  const [tranches, setTranches] = useState([
    { amount: "", account_id: "", payment_mode: "", remark: "" },
  ]);
  const [amountReceived, setAmountReceived] = useState(0);
  const [bankAmountLoanReceived, setBankAmountLoanReceived] = useState([
    { loan_amount_received_from_bank: "", bank_transfer_utr_number: "" },
  ]);
  const [amountReceivedEdit, setAmountReceivedEdit] = useState([]);
  const [accountHolder, setAccountHolder] = useState([
    {
      fore_closure_amount: "",
      account_number: "",
      bank_name: "",
      ifsc_code: "",
      branch_name: "",
      other_bank: "",
      utr_no: "",
      tranche_id: "",
      mode_of_payment: "",
      fc_closure_amount_proof: "",
    },
  ]);
  const [accountHolderEdit, setAccountHolderEdit] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  let [totalReceivedAmount, setTotalReceivedAmount] = useState(0);
  const [checkDisbursalMemo, setCheckDisbursalMemo] = useState(false);
  const [isAccountCreated, setIsAccountCreated] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await bankListRequest();
      await loanAccountRequest(match?.params?.id);
      await loanTranchesRequest(match?.params?.id);
      await loanApplicationByIdRequest(match?.params?.id);
      await newBankDetailsRequest();
      setIsLoading(false);
    })();
  }, []);

  const handleInput = (val, index, e = "", key = "") => {
    const list = [...inputList];
    list[0][key][index] = "";
    list[0][key][index] = val;
    setInputList(list);
  };

  const handleSubmit = async (e, isFinalSubmit = false) => {
    e.preventDefault();
    if (stage < 5) {
      return false;
    }

    let requestParams = inputList[0];
    if (
      requestParams["payment_details"]["prev_loan_closure"] === "Bank" &&
      bankAmountLoanReceived[0] &&
      !bankAmountLoanReceived[0]["loan_amount_received_from_bank"]
    ) {
      toast.error("Bank transfer loan details is required!");
      return;
    }

    let isValidate = false;
    let msg = "";

    // accountHolder
    if (requestParams["payment_details"]["prev_loan_closure"] === "Park+") {
      accountHolder.some((val) => {
        if (!val?.fore_closure_amount) {
          // isValidate = true;
          // msg = ;
          toast.error("Amount is missing");
          return;
        }

        // if(!val?.ifsc_code) {
        //     // isValidate = true;
        //     // msg = ;
        //     toast.error("IFSC Code k is missing");
        //     return;
        // }

        if (!val?.account_number) {
          toast.error("Account no is missing");
          // isValidate = true;
          // msg = "Bank transfer utr no is missing";
          return;
        }
        if (!val?.bank_name) {
          toast.error("Bank name is missing");
          // isValidate = true;
          // msg = "Bank transfer utr no is missing";
          return;
        }
        if (!val?.branch_name) {
          toast.error("Branch name is missing");
          // isValidate = true;
          // msg = "Bank transfer utr no is missing";
          return;
        }
        if (!val?.utr_number) {
          toast.error("UTR no is missing");
          // isValidate = true;
          // msg = "Bank transfer utr no is missing";
          return;
        }
        if (!val?.mode_of_payment) {
          toast.error("Mode of payment is missing");
          return;
        }
        if (!val?.fc_closure_amount_proof) {
          toast.error("Amount proof is missing");
          return;
        }
      });
    }
    requestParams["bank_transfer_loan_details"] = bankAmountLoanReceived;
    if (requestParams["payment_details"]["prev_loan_closure"] === "Bank") {
      bankAmountLoanReceived.some((val) => {
        if (!val?.loan_amount_received_from_bank) {
          // isValidate = true;
          // msg = ;
          toast.error("Amount received from bank is missing");
          return;
        }

        if (!val?.bank_transfer_utr_number) {
          toast.error("Bank transfer utr no is missing");
          // isValidate = true;
          // msg = "Bank transfer utr no is missing";
          return;
        }
      });
    }

    if (isValidate) {
      toast.error(msg);
      return;
    }

    if (!requestParams["payment_details"]["existing_loan"]) {
      requestParams["payment_details"]["existing_loan"] = ucdCaseByIdResponse
        ?.data?.existing_loan
        ? "Yes"
        : "No";
    }

    if (!requestParams["payment_details"]["for_closure_amount"]) {
      requestParams["payment_details"]["for_closure_amount"] =
        ucdCaseByIdResponse?.data?.fore_closure_amount;
    }

    // if(!requestParams['payment_details']['fc_closure_amount_proof']){
    //     requestParams['payment_details']['fc_closure_amount_proof'] = ucdCaseByIdResponse?.data?.fore_closure_amount_proof
    // }

    if (!requestParams["payment_details"]["prev_loan_closure"]) {
      requestParams["payment_details"]["prev_loan_closure"] =
        ucdCaseByIdResponse?.data?.previous_loan_closed_by;
    }

    if (
      !requestParams["payment_details"]["mode_of_payment"] &&
      requestParams["payment_details"]["prev_loan_closure"] === "Bank"
    ) {
      requestParams["payment_details"]["mode_of_payment"] =
        ucdCaseByIdResponse?.data?.mode_of_payment;
    }

    // if(!requestParams['payment_details']['loan_amount_from_bank']){
    //     requestParams['payment_details']['loan_amount_from_bank'] = ucdCaseByIdResponse?.data?.loan_amount_received_from_bank
    // }

    // if(!requestParams['payment_details']['utr_no']){
    //     requestParams['payment_details']['utr_no'] = ucdCaseByIdResponse?.data?.bank_transfer_utr_number
    // }

    if (!requestParams["payment_details"]["loan_closure_payment_proof"]) {
      requestParams["payment_details"]["loan_closure_payment_proof"] =
        ucdCaseByIdResponse?.data?.loan_closure_payment_proof;
    }

    if (!requestParams["hold_back_Details"]["account_id"]) {
      requestParams["hold_back_Details"]["account_id"] =
        loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id;
    }

    if (!requestParams["hold_back_Details"]["mode_of_payment"]) {
      requestParams["hold_back_Details"]["mode_of_payment"] =
        loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode;
    }

    if (!requestParams["hold_back_Details"]["remark"]) {
      requestParams["hold_back_Details"]["remark"] =
        loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.remark;
    }

    if (!requestParams["hold_back_Details"]["amount"]) {
      requestParams["hold_back_Details"]["amount"] =
        ucdCaseByIdResponse?.data?.hold_back_amount;
    }

    if (!requestParams["hold_back_Details"]["amount_approval_proof"]) {
      requestParams["hold_back_Details"]["amount_approval_proof"] =
        ucdCaseByIdResponse?.data?.hold_back_amount_proof;
    }

    if (!requestParams["undertaking"]["undertaking"]) {
      requestParams["undertaking"]["undertaking"] =
        ucdCaseByIdResponse?.data?.customer_undertaking;
    }

    // if(parseInt(requestParams['payment_details']['loan_amount_from_bank']) > 2000000 && !requestParams['hold_back_Details']['amount_approval_proof']){
    //     toast.error("Hold back amount  proof is missing!");
    //     return false;
    // }

    setIsAccountCreated(false);
    requestParams["tranches"] = tranches;
    requestParams["case_id"] = match?.params?.id;
    setIsLoading(true);
    if (requestParams["payment_details"]["prev_loan_closure"] === "Park+") {
      await foreClosureAddAccountRequest({
        loan_application_id: match?.params?.id,
        fore_closure_payment_details: accountHolder,
        total_fore_closure_amount:
          requestParams["payment_details"]["for_closure_amount"],
      });
    } else {
      await handleFinalHit();
    }
    setIsLoading(false);
  };

  const handleFinalHit = async () => {
    setIsLoading(true);
    let requestParams = inputList[0];
    requestParams["tranches"] = tranches;
    requestParams["case_id"] = match?.params?.id;
    requestParams["bank_transfer_loan_details"] = bankAmountLoanReceived;
    if (
      ucdCaseByIdResponse?.data &&
      ucdCaseByIdResponse?.data?.status !== "APPROVED"
    ) {
      console.log("update");
      await loanPaymentRaiseUpdateRequest(requestParams);
    } else {
      console.log("create");
      await loanPaymentRaiseRequest(requestParams);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    (async () => {
      if (isAccountCreated) {
        await handleFinalHit();
      }
    })();
  }, [isAccountCreated]);

  const handleAddTranches = (e) => {
    e.preventDefault();
    setTranches([
      ...tranches,
      { amount: "", account_id: "", payment_mode: "", remark: "" },
    ]);
  };

  const handleRemoveTranches = (e, index) => {
    e.preventDefault();
    let list = [...tranches];
    list.splice(index, 1);
    setTranches(list);
  };

  const handleTrancheInput = (val, key, index) => {
    const list = [...tranches];
    list[index][key] = val;
    setTranches(list);
  };

  const handleStage = (stageNo) => {
    let list = [...inputList];
    setCheckDisbursalMemo(false);
    let isTrue = false;
    let errorMsg = "";
    // if(stageNo === 3){
    //     if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 2000000 && !inputList[0]['hold_back_Details']['amount_approval_proof']){
    //         toast.error("Hold back amount  proof is missing!");
    //         return false;
    //     }
    //
    // }
    //
    // if(stageNo === 3){
    //     if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 1000000
    //         && (parseInt(inputList[0].hold_back_Details['amount']) > 20000 || parseInt(inputList[0].hold_back_Details['amount']) < 20000)
    //         && !inputList[0]['hold_back_Details']['amount_approval_proof']){
    //         toast.error("Hold back amount  proof is missing!");
    //         return false;
    //     }
    // }
    //
    // if(stageNo === 3){
    //     if(parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) > 1000000 &&  parseInt(inputList[0].hold_back_Details['loan_amount_from_bank']) < 2000000
    //         && (parseInt(inputList[0].hold_back_Details['amount']) > 40000 || parseInt(inputList[0].hold_back_Details['amount']) < 40000)
    //         && !inputList[0]['hold_back_Details']['amount_approval_proof']){
    //         toast.error("Hold back amount  proof is missing!");
    //         return false;
    //     }
    // }

    if (stageNo - 1 === 1) {
      if (
        list[0]["payment_details"]["prev_loan_closure"] === "Bank" &&
        !bankAmountLoanReceived[0]["loan_amount_received_from_bank"]
      ) {
        toast.error("Bank transfer loan details is required!");
        return;
      }

      if (list[0]["payment_details"]["prev_loan_closure"] === "Park+") {
        accountHolder.some((val) => {
          if (!val?.fore_closure_amount) {
            isTrue = true;
            errorMsg = "Fill all the details";
            return;
          }
          if (!val?.account_number) {
            // toast.error("Account no is missing");
            isTrue = true;
            errorMsg = "Fore closure account no is missing";
            return;
          }
          // if(!val?.ifsc_code) {
          //     isTrue = true;
          //     errorMsg = 'Fore closure IFSC Code is missing';
          //     // toast.error("IFSC Code is missing");
          //     return;
          // }

          if (!val?.bank_name) {
            // toast.error("Bank name is missing");
            isTrue = true;
            errorMsg = "Fore closure bank name is missing";
            return;
          }
          if (!val?.branch_name) {
            // toast.error("Branch name is missing");
            isTrue = true;
            errorMsg = "Fore closure branch name is missing";
            return;
          }
          if (!val?.utr_number) {
            isTrue = true;
            errorMsg = "UTR no is missing";
            return;
          }
          if (!val?.mode_of_payment) {
            isTrue = true;
            errorMsg = "Mode of payment is missing";
            return;
          }
          if (!val?.fc_closure_amount_proof) {
            isTrue = true;
            errorMsg = "Amount proof is missing";
            return;
          }
        });
      }

      // mode_of_payment
      if (list[0]["payment_details"]["prev_loan_closure"] === "Bank") {
        if (!list[0]["payment_details"]["mode_of_payment"]) {
          toast.error("Mode of payment is missing!");
          return;
        }
      }
      if (list[0]["payment_details"]["prev_loan_closure"] === "Bank") {
        bankAmountLoanReceived.some((val) => {
          if (!val?.loan_amount_received_from_bank) {
            isTrue = true;
            // toast.error("Amount received from bank is missing");
            errorMsg = "Amount received from bank is missing";
            return;
          }

          if (!val?.bank_transfer_utr_number) {
            isTrue = true;
            errorMsg = "Bank transfer utr no is missing";
            // toast.error("Bank transfer utr no is missing");
            return;
          }
        });
      }

      if (
        ucdCaseByIdResponse?.data?.loan_approved_amount < totalReceivedAmount
      ) {
        toast.error(
          "Total received amount can't be greater than approved amount!"
        );
        return;
      }

      // if(!list[0].payment_details['disbursal_date']){
      //     isTrue = true;
      //     toast.error("Disbursal date is missing!");
      //     return ;
      // }
      //
      // if(!list[0].payment_details['disbursal_memo']){
      //     isTrue = true;
      //     toast.error("Disbursal memo is missing!");
      //     return ;
      // }

      if (isTrue && errorMsg) {
        toast.error(errorMsg);
        isTrue ? setStage(stageNo - 1) : setStage(stageNo);
        return;
      }

      // if(ucdCaseByIdResponse?.data?.bank_transfer_loan_details &&
      //     ucdCaseByIdResponse?.data?.bank_transfer_loan_details.length > 0 &&
      //     ucdCaseByIdResponse?.data?.bank_transfer_loan_details[0] &&
      //     ucdCaseByIdResponse?.data?.bank_transfer_loan_details[0]?.loan_amount_received_from_bank){
      //     if(isTrue && errorMsg){
      //         toast.error(errorMsg)
      //         isTrue ? setStage(stageNo - 1) : setStage(stageNo);
      //     } else {
      //         setStage(stageNo)
      //     }
      //
      //     return false;
      // }

      Object.keys(list[0].payment_details).forEach((key) => {
        if (list[0].payment_details["existing_loan"] === "No") {
          // isTrue = !list[0].payment_details['loan_amount_from_bank'];
          // isTrue = !list[0].payment_details['utr_no'];
        } else {
          if (
            !list[0].payment_details[key] &&
            list[0]["payment_details"]["prev_loan_closure"] === "Bank"
          ) {
            errorMsg =
              key.charAt(0).toUpperCase().replaceAll("_", " ") +
              key.slice(1).replaceAll("_", " ") +
              " is required";
            isTrue = true;
          }
        }
        // isTrue = !list[0].payment_details['disbursal_date'];
        // if(!list[0].payment_details['disbursal_memo']){
        //     setCheckDisbursalMemo(true)
        //     isTrue = true
        // }
      });
    }

    // if (stageNo - 1 === 2) {
    //     Object.keys(list[0].dealer_details).forEach((key) => {
    //         if (!list[0].dealer_details[key]) {
    //             isTrue = true;
    //         }
    //     })
    // }

    if (
      ucdCaseByIdResponse?.data?.bank_transfer_loan_details[0]
        ?.loan_amount_received_from_bank
    ) {
      setStage(stageNo);
      return;
    }
    if (stageNo - 1 === 3) {
      Object.keys(list[0].hold_back_Details).forEach((key) => {
        if (
          !list[0].hold_back_Details[key] &&
          key !== "amount_approval_proof" &&
          key !== "status"
        ) {
          isTrue = true;
        }

        if (
          parseInt(amountReceived) !==
            parseInt(list[0].hold_back_Details["amount"]) &&
          key === "amount_approval_proof" &&
          !list[0].hold_back_Details[key]
        ) {
          errorMsg = "Document for amount proof is required!";
          isTrue = true;
        }
      });
    }

    if (stageNo - 1 === 4) {
      tranches.map((val) => {
        console.log(val);
        Object.keys(val).forEach((key) => {
          if (!key) {
            isTrue = true;
          }
        });
      });
    }
    if (isTrue && errorMsg) {
      toast.error(errorMsg);
    }
    console.log(isTrue, errorMsg);
    isTrue ? setStage(stageNo - 1) : setStage(stageNo);
  };

  // useEffect(() => {
  //     if(loanAccountResponse?.DEALER){
  //         let list = [...inputList];
  //         list[0]['dealer_details'] = {
  //             account_number: loanAccountResponse?.DEALER?.account_number,
  //             bank_name: loanAccountResponse?.DEALER?.bank_name,
  //             ifsc_code: loanAccountResponse?.DEALER?.ifsc_code,
  //             branch_name: loanAccountResponse?.DEALER?.branch_name,
  //         };
  //         setInputList(list)
  //     }
  // }, [loanAccountResponse])

  useEffect(() => {
    if (parseInt(loanPaymentRaiseResponse?.status) === 200) {
      toast.success(loanPaymentRaiseResponse?.message);
      window.location.href = `ucd-case-list-v2/${match?.params?.dealer_id}/${match?.params?.lsq_dealer_id}`;
    } else if (parseInt(loanPaymentRaiseResponse?.status) !== 200) {
      toast.error(loanPaymentRaiseResponse?.message);
    }
  }, [loanPaymentRaiseResponse]);

  useEffect(() => {
    if (parseInt(loanApplicationUpdateResponse?.status) === 200) {
      toast.success(loanApplicationUpdateResponse?.message);
      window.location.href = `ucd-case-list-v2/${match?.params?.dealer_id}/${match?.params?.lsq_dealer_id}`;
    } else if (parseInt(loanApplicationUpdateResponse?.status) !== 200) {
      toast.error(loanApplicationUpdateResponse?.message);
    }
  }, [loanApplicationUpdateResponse]);

  useEffect(() => {
    if (parseInt(foreClosureAddAccountResponse?.status) === 200) {
      setIsAccountCreated(true);
    } else if (parseInt(foreClosureAddAccountResponse?.status) !== 200) {
      toast.error(foreClosureAddAccountResponse?.message);
    }
  }, [foreClosureAddAccountResponse]);

  useEffect(() => {
    if (loanTranchesResponse?.data) {
      let list = [...inputList];

      if (loanTranchesResponse?.data?.HOLD_BACK_TRANCHE) {
        list[0]["hold_back_Details"]["account_id"] =
          loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id;
        list[0]["hold_back_Details"]["mode_of_payment"] =
          loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode;
        list[0]["hold_back_Details"]["remark"] =
          loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.remark;
        list[0]["hold_back_Details"]["status"] =
          loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.status;
        if (loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.utr_number) {
          list[0]["hold_back_Details"]["utr_number"] =
            loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.utr_number;
        }
        if (loanTranchesResponse?.data?.TRANCHES.length > 0) {
          setTranches(loanTranchesResponse?.data?.TRANCHES);
        }
      }

      list[0]["dealer_details"] = {
        account_number: loanAccountResponse?.DEALER?.account_number,
        bank_name: loanAccountResponse?.DEALER?.bank_name,
        ifsc_code: loanAccountResponse?.DEALER?.ifsc_code,
        branch_name: loanAccountResponse?.DEALER?.branch_name,
      };

      if (ucdCaseByIdResponse?.data) {
        list[0]["payment_details"] = {
          existing_loan: ucdCaseByIdResponse?.data?.existing_loan
            ? "Yes"
            : "No",
          for_closure_amount: ucdCaseByIdResponse?.data?.fore_closure_amount,
          // fc_closure_amount_proof: ucdCaseByIdResponse?.data?.fore_closure_amount_proof,
          mode_of_payment: ucdCaseByIdResponse?.data?.mode_of_payment,
          // loan_amount_from_bank: ucdCaseByIdResponse?.data?.loan_amount_received_from_bank,
          utr_no: ucdCaseByIdResponse?.data?.bank_transfer_utr_number,
          // loan_closure_payment_proof: ucdCaseByIdResponse?.data?.loan_closure_payment_proof,
          prev_loan_closure: ucdCaseByIdResponse?.data?.previous_loan_closed_by,
          // disbursal_memo: ucdCaseByIdResponse?.data?.disbursal_memo,
          // disbursal_date: ucdCaseByIdResponse?.data?.disbursal_date,
        };

        if (
          ucdCaseByIdResponse?.data?.bank_transfer_loan_details &&
          ucdCaseByIdResponse?.data?.bank_transfer_loan_details.length > 0
        ) {
          // eslint-disable-next-line no-unused-expressions
          ucdCaseByIdResponse?.data?.bank_transfer_loan_details.map(
            (val, i) => {
              if (!amountReceivedEdit[i]) {
                amountReceivedEdit[i] = true;
              }
            }
          );
          setAmountReceivedEdit(amountReceivedEdit);
          setBankAmountLoanReceived(
            ucdCaseByIdResponse?.data?.bank_transfer_loan_details
          );
        }
        if (
          ucdCaseByIdResponse?.data?.bank_transfer_loan_details &&
          ucdCaseByIdResponse?.data?.bank_transfer_loan_details?.length > 0
        ) {
          const editStates =
            ucdCaseByIdResponse.data.bank_transfer_loan_details.map(() => true);
          setAmountReceivedEdit(editStates);
          setBankAmountLoanReceived(
            ucdCaseByIdResponse.data.bank_transfer_loan_details
          );
        }

        if (
          ucdCaseByIdResponse?.data?.fore_closure_account_details &&
          ucdCaseByIdResponse?.data?.fore_closure_account_details.length > 0
        ) {
          // eslint-disable-next-line no-unused-expressions
          ucdCaseByIdResponse?.data?.fore_closure_account_details.map(
            (val, i) => {
              if (!accountHolderEdit[i]) {
                accountHolderEdit[i] = true;
              }
              let bankList = [];
              newBankDetailsResponse.map((val) => {
                bankList.push(val?.name);
              });

              accountHolder[i] = {
                bank_name: bankList.includes(val?.bank_name)
                  ? val?.bank_name
                  : "Other",
                account_number: val?.account_number,
                ifsc_code: val?.ifsc_code,
                branch_name: val?.branch_name,
                fore_closure_amount: val?.fore_closure_amount,
                utr_number: val?.utr_number,
                mode_of_payment: val?.mode_of_payment,
                fc_closure_amount_proof: val?.fore_closure_amount_proof,
                tranche_id: val?.tranche_id ?? null,
                tranche_status:
                  val?.tranche_status !== "REQUEST_FOR_MODIFICATION",
                other_bank: !bankList.includes(val?.bank_name)
                  ? val?.bank_name
                  : "",
              };
            }
          );

          setAccountHolderEdit(accountHolderEdit);
          setAccountHolder(accountHolder);
        }

        list[0]["hold_back_Details"]["amount"] =
          ucdCaseByIdResponse?.data?.hold_back_amount ?? null;
        list[0]["hold_back_Details"]["amount_approval_proof"] =
          ucdCaseByIdResponse?.data?.hold_back_amount_proof;

        let amount = 0;
        if (!list[0]["hold_back_Details"]["amount"]) {
          if (
            parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) <= 1000000
          ) {
            amount = 20000;
          } else if (
            parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) >
              1000000 &&
            parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) < 2000000
          ) {
            amount = 40000;
          }
          if (amount) {
            handleInput(amount, "amount", "", "hold_back_Details");
          }
          setAmountReceived(amount);
        }
      }
      console.log("list", list);
      setInputList(list);
    }
  }, [
    loanTranchesResponse,
    ucdCaseByIdResponse,
    loanAccountResponse,
    newBankDetailsResponse,
  ]);

  const handlePaymentRelease = async () => {
    setIsLoading(true);
    await loanApprovalRequestRequest({
      loan_id: match?.params?.id,
      status: "REQUEST_FOR_PAYMENT_RELEASE",
    });
    setIsLoading(false);
  };

  useEffect(() => {
    if (parseInt(loanPaymentRaiseUpdateResponse?.status) === 200) {
      toast.success(loanPaymentRaiseUpdateResponse?.message);
      window.location.href = `ucd-case-list-v2/${match?.params?.dealer_id}/${match?.params?.lsq_dealer_id}`;
    } else if (parseInt(loanPaymentRaiseUpdateResponse?.status) !== 200) {
      toast.error(loanPaymentRaiseUpdateResponse?.message);
    }
  }, [loanPaymentRaiseUpdateResponse]);

  useEffect(() => {
    if (parseInt(loanApprovalRequestResponse?.status) === 200) {
      toast.success(loanApprovalRequestResponse?.message);
      window.location.href = `ucd-case-list-v2/${match?.params?.dealer_id}/${match?.params?.lsq_dealer_id}`;
    } else if (parseInt(loanApprovalRequestResponse?.status) !== 200) {
      toast.error(loanApprovalRequestResponse?.message);
    }
  }, [loanApprovalRequestResponse]);

  useEffect(() => {
    let amount = 0;
    if (!ucdCaseByIdResponse?.data) {
      return;
    }
    if (parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) <= 1000000) {
      amount = 20000;
    } else if (
      parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) > 1000000 &&
      parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) < 2000000
    ) {
      amount = 40000;
    }
    if (amount) {
      handleInput(amount, "amount", "", "hold_back_Details");
    }

    setAmountReceived(amount);
  }, [ucdCaseByIdResponse]);

  const handleAddAmountReceivedFromBank = (e) => {
    e.preventDefault();
    setBankAmountLoanReceived([
      ...bankAmountLoanReceived,
      { loan_amount_received_from_bank: "", bank_transfer_utr_number: "" },
    ]);
  };

  const handleRemoveAmountReceivedFromBank = (e, index) => {
    e.preventDefault();
    let list = [...bankAmountLoanReceived];
    list.splice(index, 1);
    setBankAmountLoanReceived(list);
  };

  const handleAmountReceivedFromBankInput = (val, key, index) => {
    const list = [...bankAmountLoanReceived];
    list[index][key] = val;
    totalReceivedAmount = 0;
    list.map((val) => {
      totalReceivedAmount += parseInt(val?.loan_amount_received_from_bank);
    });
    console.log(totalReceivedAmount);
    setTotalReceivedAmount(totalReceivedAmount);
    setBankAmountLoanReceived(list);
  };

  const handleAddAccountHolder = () => {
    setAccountHolder([
      ...accountHolder,
      {
        fore_closure_amount: "",
        account_number: "",
        bank_name: "",
        ifsc_code: "",
        branch_name: "",
        other_bank: "",
        utr_no: "",
        tranche_id: "",
        mode_of_payment: "",
        fc_closure_amount_proof: "",
      },
    ]);
  };

  const handleRemoveAccountHolder = (e, index) => {
    e.preventDefault();
    let list = [...accountHolder];
    list.splice(index, 1);
    setAccountHolder(list);
  };

  const handleAccountHolderInput = (val, key, index) => {
    const list = [...accountHolder];
    list[index][key] = val;
    setAccountHolder(list);
  };

  useEffect(() => {
    if (checkDisbursalMemo) {
      toast.error("Disbursal memo is missing!");
    }
    setCheckDisbursalMemo(false);
  }, [checkDisbursalMemo]);

  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Payment Raise"} history={history} />
            {/*BODY*/}
            <div>
              <div className="container-fluid">
                <div className="container-v2">
                  <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.0.3/css/font-awesome.css"
                  />
                  <div id="msform">
                    <ul id="progressbar">
                      <li
                        id="confirm"
                        className={`${stage < 2 ? "active" : "done"}`}
                      >
                        <span className="pb-v2">
                          <strong>Payment</strong>
                        </span>
                      </li>
                      <li
                        id="confirm"
                        className={`${
                          stage == 2
                            ? "active"
                            : stage > 2
                            ? "done"
                            : "inactive"
                        }`}
                      >
                        <span className="pb-v2">
                          <strong>Dealer</strong>
                        </span>
                      </li>
                      <li
                        id="confirm"
                        className={`${
                          stage == 3
                            ? "active"
                            : stage > 3
                            ? "done"
                            : "inactive"
                        }`}
                      >
                        <span className="pb-v2">
                          <strong>Hold Back Amount</strong>
                        </span>
                      </li>
                      <li
                        id="confirm"
                        className={`${
                          stage == 4
                            ? "active"
                            : stage > 4
                            ? "done"
                            : "inactive"
                        }`}
                      >
                        <span className="pb-v2">
                          <strong>Tranches</strong>
                        </span>
                      </li>
                      <li
                        id="confirm"
                        className={`${
                          stage == 5
                            ? "active"
                            : stage > 5
                            ? "done"
                            : "inactive"
                        }`}
                      >
                        <span className="pb-v2">
                          <strong>Undertaking</strong>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <form onSubmit={(e) => handleSubmit(e, true)}>
                  {stage === 1 && (
                    <>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                          </div>
                          <div className="mb-4 bg-white">
                            {" "}
                            {/*card*/}
                            <div className="hide card-header bg-lightGreen-active">
                              Payment Details
                            </div>
                            <div className="card-body">
                              <div className="user">
                                <div className="form-group row">
                                  <div
                                    className="col-sm-6 col-md-6 mt-1 float-field"
                                    style={{ marginTop: "16px !important" }}
                                  >
                                    <select
                                      className="form-control form-control-user"
                                      onChange={(e) => {
                                        handleInput(
                                          e.target.value,
                                          "existing_loan",
                                          e,
                                          "payment_details"
                                        );
                                      }}
                                      required
                                    >
                                      <option value="">Existing Loan</option>
                                      <option
                                        value="Yes"
                                        selected={
                                          inputList[0]["payment_details"][
                                            "existing_loan"
                                          ] === "Yes"
                                        }
                                      >
                                        Yes
                                      </option>
                                      <option
                                        value="No"
                                        selected={
                                          inputList[0]["payment_details"][
                                            "existing_loan"
                                          ] === "No"
                                        }
                                      >
                                        No
                                      </option>
                                    </select>
                                    <label className="large-label float-lb">
                                      Existing Loan{" "}
                                      <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  {inputList[0]["payment_details"][
                                    "existing_loan"
                                  ] === "Yes" && (
                                    <>
                                      <div className="col-sm-6 col-md-6 mt-1 float-field">
                                        <input
                                          type="text"
                                          className="form-control form-control-user"
                                          placeholder=" "
                                          onChange={(e) => {
                                            const value = e.target.value
                                              .replace(/[^0-9.]/g, "") // Remove non-numeric and non-decimal characters
                                              .replace(/^(\.)/, "") // Prevent leading decimal points
                                              .replace(/(\..*?)\..*/g, "$1"); // Remove non-numeric characters
                                            handleInput(
                                              value,
                                              "for_closure_amount",
                                              e,
                                              "payment_details"
                                            );
                                            e.target.value = value;
                                          }}
                                          value={
                                            inputList[0]["payment_details"][
                                              "for_closure_amount"
                                            ]
                                          }
                                          // step="any"      // Allows decimal input
                                          // inputMode="decimal"
                                          // disabled={isEdit}
                                          required={true}
                                        />
                                        <label className="large-label float-lb">
                                          Fore Closure Amount{" "}
                                          <i className="bi bi-asterisk astrick-icon"></i>
                                        </label>
                                      </div>
                                      <div
                                        className="col-sm-6 mt-1 float-field"
                                        style={{ marginTop: "16px !important" }}
                                      >
                                        <select
                                          className="form-control form-control-user"
                                          onChange={(e) => {
                                            handleInput(
                                              e.target.value,
                                              "prev_loan_closure",
                                              e,
                                              "payment_details"
                                            );
                                          }}
                                          required={true}
                                        >
                                          <option value="">
                                            Previous Loan Closure By
                                          </option>
                                          <option
                                            value="Bank"
                                            selected={
                                              inputList[0]["payment_details"][
                                                "prev_loan_closure"
                                              ] === "Bank"
                                            }
                                          >
                                            Bank
                                          </option>
                                          <option
                                            value="Park+"
                                            selected={
                                              inputList[0]["payment_details"][
                                                "prev_loan_closure"
                                              ] === "Park+"
                                            }
                                          >
                                            Park+
                                          </option>
                                        </select>
                                        <label className="large-label float-lb">
                                          Previous Loan Closure By{" "}
                                          <i className="bi bi-asterisk astrick-icon"></i>
                                        </label>
                                      </div>
                                      {inputList[0]["payment_details"][
                                        "prev_loan_closure"
                                      ] === "Bank" && (
                                        <div className="col-sm-6 col-md-6 mt-1 float-field">
                                          <input
                                            type="text"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              handleInput(
                                                e.target.value,
                                                "utr_no",
                                                e,
                                                "payment_details"
                                              );
                                            }}
                                            value={
                                              inputList[0]["payment_details"][
                                                "utr_no"
                                              ]
                                            }
                                            required
                                          />
                                          <label className="large-label float-lb">
                                            Transaction Proof No{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </label>
                                        </div>
                                      )}
                                      {inputList[0]["payment_details"][
                                        "prev_loan_closure"
                                      ] === "Park+" && (
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div className="d-sm-flex align-items-center justify-content-between com-sub-heading"></div>
                                            <div className="mb-4 mt-2 bg-white">
                                              {" "}
                                              {/*card*/}
                                              <div className=" card-header bg-lightGreen-active">
                                                Fore Closure Details
                                              </div>
                                              <div className="card-body">
                                                <div className="user">
                                                  <div className="form-group row">
                                                    {accountHolder.map(
                                                      (val, i) => {
                                                        return (
                                                          <>
                                                            <div className="bg-white mt-2">
                                                              {" "}
                                                              {/*card*/}
                                                              <div className=" card-header bg-lightGreen-active">
                                                                {`Fore Closure ${
                                                                  i + 1
                                                                }`}
                                                              </div>
                                                              <div
                                                                className="card-body"
                                                                style={{
                                                                  border:
                                                                    "1px solid gainsboro",
                                                                }}
                                                              >
                                                                <div className="row">
                                                                  <div className="form-group row">
                                                                    <div className="col-sm-6 col-md-6 mt-3 float-field">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control form-control-user"
                                                                        placeholder=" "
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          const value =
                                                                            e.target.value
                                                                              .replace(
                                                                                /[^0-9.]/g,
                                                                                ""
                                                                              ) // Remove non-numeric and non-decimal characters
                                                                              .replace(
                                                                                /^(\.)/,
                                                                                ""
                                                                              ) // Prevent leading decimal points
                                                                              .replace(
                                                                                /(\..*?)\..*/g,
                                                                                "$1"
                                                                              ); // Remove non-numeric characters
                                                                          handleAccountHolderInput(
                                                                            value,
                                                                            "fore_closure_amount",
                                                                            i
                                                                          );
                                                                          e.target.value =
                                                                            value;
                                                                        }}
                                                                        // step={"any"}
                                                                        // decimal={"decimal"}
                                                                        value={
                                                                          val?.fore_closure_amount
                                                                        }
                                                                        required={
                                                                          true
                                                                        }
                                                                        disabled={
                                                                          accountHolderEdit[
                                                                            i
                                                                          ]
                                                                        }
                                                                      />
                                                                      <label className="large-label float-lb">
                                                                        Amount
                                                                        to be
                                                                        transfer{" "}
                                                                        <i className="bi bi-asterisk astrick-icon"></i>
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-sm-6 col-md-6 mt-3 float-field">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control form-control-user"
                                                                        placeholder=" "
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          // const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                                                          handleAccountHolderInput(
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            "account_number",
                                                                            i
                                                                          );
                                                                          // e.target.value = value;
                                                                        }}
                                                                        value={
                                                                          val?.account_number
                                                                        }
                                                                        required={
                                                                          true
                                                                        }
                                                                        disabled={
                                                                          accountHolderEdit[
                                                                            i
                                                                          ]
                                                                        }
                                                                      />
                                                                      <label className="large-label float-lb">
                                                                        Account
                                                                        Number{" "}
                                                                        <i className="bi bi-asterisk astrick-icon"></i>
                                                                      </label>
                                                                    </div>
                                                                    <div
                                                                      className="col-sm-6 col-md-6 mt-3 float-field"
                                                                      style={{
                                                                        marginTop:
                                                                          "16px !important",
                                                                      }}
                                                                    >
                                                                      <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          handleAccountHolderInput(
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            "bank_name",
                                                                            i
                                                                          );
                                                                        }}
                                                                        disabled={
                                                                          accountHolderEdit[
                                                                            i
                                                                          ]
                                                                        }
                                                                      >
                                                                        <option value="">
                                                                          Bank
                                                                          Name
                                                                        </option>
                                                                        {newBankDetailsResponse.map(
                                                                          (
                                                                            value
                                                                          ) => {
                                                                            return (
                                                                              <>
                                                                                <option
                                                                                  value={
                                                                                    value?.id
                                                                                  }
                                                                                  selected={
                                                                                    val?.bank_name ===
                                                                                    value?.id
                                                                                  }
                                                                                >
                                                                                  {
                                                                                    value?.id
                                                                                  }
                                                                                </option>
                                                                              </>
                                                                            );
                                                                          }
                                                                        )}
                                                                      </select>
                                                                      <label className="large-label float-lb">
                                                                        Bank
                                                                        Name{" "}
                                                                        <i className="bi bi-asterisk astrick-icon"></i>
                                                                      </label>
                                                                    </div>
                                                                    {val?.bank_name ===
                                                                      "Other" && (
                                                                      <div className="col-sm-6 col-md-6 mt-3 float-field">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control form-control-user"
                                                                          placeholder=" "
                                                                          onChange={(
                                                                            e
                                                                          ) => {
                                                                            handleAccountHolderInput(
                                                                              e
                                                                                .target
                                                                                .value,
                                                                              "other_bank",
                                                                              i
                                                                            );
                                                                          }}
                                                                          value={
                                                                            val?.other_bank
                                                                          }
                                                                          required={
                                                                            true
                                                                          }
                                                                          disabled={
                                                                            accountHolderEdit[
                                                                              i
                                                                            ]
                                                                          }
                                                                        />
                                                                        <label className="large-label float-lb">
                                                                          Bank
                                                                          Name{" "}
                                                                          <i className="bi bi-asterisk astrick-icon"></i>
                                                                        </label>
                                                                      </div>
                                                                    )}
                                                                    <div className="col-sm-6 col-md-6 mt-3 float-field">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control form-control-user"
                                                                        placeholder=" "
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          handleAccountHolderInput(
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            "ifsc_code",
                                                                            i
                                                                          );
                                                                        }}
                                                                        maxLength={
                                                                          11
                                                                        }
                                                                        minLength={
                                                                          11
                                                                        }
                                                                        value={
                                                                          val?.ifsc_code
                                                                        }
                                                                        disabled={
                                                                          accountHolderEdit[
                                                                            i
                                                                          ]
                                                                        }
                                                                      />
                                                                      <label className="large-label float-lb">
                                                                        IFSC
                                                                        Code
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-sm-6 col-md-6 mt-3 float-field">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control form-control-user"
                                                                        placeholder=" "
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          handleAccountHolderInput(
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            "branch_name",
                                                                            i
                                                                          );
                                                                        }}
                                                                        value={
                                                                          val?.branch_name
                                                                        }
                                                                        required={
                                                                          true
                                                                        }
                                                                        disabled={
                                                                          accountHolderEdit[
                                                                            i
                                                                          ]
                                                                        }
                                                                      />
                                                                      <label className="large-label float-lb">
                                                                        Branch
                                                                        Name{" "}
                                                                        <i className="bi bi-asterisk astrick-icon"></i>
                                                                      </label>
                                                                    </div>

                                                                    <div className="col-sm-6 col-md-6 mt-3 float-field">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control form-control-user"
                                                                        placeholder=" "
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          handleAccountHolderInput(
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            "utr_number",
                                                                            i
                                                                          );
                                                                        }}
                                                                        required={
                                                                          true
                                                                        }
                                                                        value={
                                                                          val?.utr_number
                                                                        }
                                                                        disabled={
                                                                          val.tranche_status
                                                                        }
                                                                      />
                                                                      <label className="large-label float-lb">
                                                                        Utr No{" "}
                                                                        <i className="bi bi-asterisk astrick-icon"></i>
                                                                      </label>
                                                                    </div>
                                                                    <div
                                                                      className="col-sm-6 mt-1 float-field"
                                                                      style={{
                                                                        marginTop:
                                                                          "16px !important",
                                                                      }}
                                                                    >
                                                                      <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          handleAccountHolderInput(
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            "mode_of_payment",
                                                                            i
                                                                          );
                                                                        }}
                                                                        required={
                                                                          true
                                                                        }
                                                                        disabled={
                                                                          accountHolderEdit[
                                                                            i
                                                                          ]
                                                                        }
                                                                      >
                                                                        <option value="">
                                                                          Mode
                                                                          of
                                                                          payment
                                                                        </option>
                                                                        <option
                                                                          value="DD"
                                                                          selected={
                                                                            val[
                                                                              "mode_of_payment"
                                                                            ] ===
                                                                            "DD"
                                                                          }
                                                                        >
                                                                          DD
                                                                        </option>
                                                                        <option
                                                                          value="RTGS"
                                                                          selected={
                                                                            val[
                                                                              "mode_of_payment"
                                                                            ] ===
                                                                            "RTGS"
                                                                          }
                                                                        >
                                                                          RTGS
                                                                        </option>
                                                                        <option
                                                                          value="NEFT"
                                                                          selected={
                                                                            val[
                                                                              "mode_of_payment"
                                                                            ] ===
                                                                            "NEFT"
                                                                          }
                                                                        >
                                                                          NEFT
                                                                        </option>
                                                                        <option
                                                                          value="Other"
                                                                          selected={
                                                                            val[
                                                                              "mode_of_payment"
                                                                            ] ===
                                                                            "Other"
                                                                          }
                                                                        >
                                                                          Other
                                                                        </option>
                                                                      </select>
                                                                      <label className="large-label float-lb">
                                                                        Mode of
                                                                        payment
                                                                        <i className="bi bi-asterisk astrick-icon"></i>
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-sm-12 float-field mt-2 mb-2">
                                                                      <FileUpload
                                                                        id={`fc_closure_amount`}
                                                                        accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                                        documentUploadUrl={
                                                                          documentUploadUrlPublic
                                                                        }
                                                                        documentUrlData={
                                                                          documentUrlDataPublic
                                                                        }
                                                                        onChange={(
                                                                          val
                                                                        ) => {
                                                                          handleAccountHolderInput(
                                                                            val,
                                                                            "fc_closure_amount_proof",
                                                                            i
                                                                          );
                                                                        }}
                                                                        disabled={
                                                                          amountReceivedEdit[
                                                                            i
                                                                          ]
                                                                        }
                                                                        prefilledFilename={
                                                                          val?.fc_closure_amount_proof
                                                                            ? "FC Closure Amount Proof"
                                                                            : ""
                                                                        }
                                                                      >
                                                                        FC
                                                                        Closure
                                                                        Amount
                                                                        Proof{" "}
                                                                        <i className="bi bi-asterisk astrick-icon"></i>
                                                                      </FileUpload>
                                                                    </div>
                                                                    {console.log(
                                                                      "fc_closure_amount_proof",
                                                                      val
                                                                    )}
                                                                    <div className="col-md-12 mb-4">
                                                                      {accountHolder.length !==
                                                                        1 &&
                                                                        !accountHolderEdit[
                                                                          i
                                                                        ] && (
                                                                          <button
                                                                            onClick={(
                                                                              e
                                                                            ) =>
                                                                              handleRemoveAccountHolder(
                                                                                e,
                                                                                i
                                                                              )
                                                                            }
                                                                            className="btn btn-sm btn-danger"
                                                                          >
                                                                            {" "}
                                                                            -
                                                                            Remove
                                                                            Foreclosure
                                                                            Tranche
                                                                          </button>
                                                                        )}
                                                                      {accountHolder.length -
                                                                        1 ===
                                                                        i && (
                                                                        <button
                                                                          className="btn btn-sm btn-primary mt-3"
                                                                          onClick={(
                                                                            e
                                                                          ) =>
                                                                            handleAddAccountHolder()
                                                                          }
                                                                        >
                                                                          + Add
                                                                          another
                                                                          Foreclosure
                                                                          Tranche
                                                                        </button>
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {/*<div*/}
                                      {/*    className="col-sm-6 mt-1 float-field"*/}
                                      {/*    style={{marginTop: "16px !important"}}>*/}
                                      {/*    <select*/}
                                      {/*        className="form-control form-control-user"*/}
                                      {/*        onChange={(e) => {*/}
                                      {/*            handleInput(e.target.value, 'mode_of_payment', e, 'payment_details')*/}
                                      {/*        }} required={true}>*/}
                                      {/*        <option value="">Mode of payment*/}
                                      {/*        </option>*/}
                                      {/*        <option*/}
                                      {/*            value="DD"*/}
                                      {/*            selected={inputList[0]['payment_details']['mode_of_payment'] === 'DD'}>DD*/}
                                      {/*        </option>*/}
                                      {/*        <option*/}
                                      {/*            value="RTGS"*/}
                                      {/*            selected={inputList[0]['payment_details']['mode_of_payment'] === 'RTGS'}>RTGS*/}
                                      {/*        </option>*/}
                                      {/*        <option*/}
                                      {/*            value="NEFT"*/}
                                      {/*            selected={inputList[0]['payment_details']['mode_of_payment'] === 'NEFT'}>NEFT*/}
                                      {/*        </option>*/}
                                      {/*        <option*/}
                                      {/*            value="Other"*/}
                                      {/*            selected={inputList[0]['payment_details']['mode_of_payment'] === 'Other'}>Other*/}
                                      {/*        </option>*/}

                                      {/*    </select>*/}
                                      {/*    <label*/}
                                      {/*        className="large-label float-lb">*/}
                                      {/*        Mode of payment for Loan Closure <i*/}
                                      {/*        className="bi bi-asterisk astrick-icon"></i>*/}
                                      {/*    </label>*/}
                                      {/*</div>*/}
                                      {inputList[0]["payment_details"][
                                        "prev_loan_closure"
                                      ] === "Bank" && (
                                        <div
                                          className="col-sm-6 mt-1 float-field"
                                          style={{
                                            marginTop: "16px !important",
                                          }}
                                        >
                                          <select
                                            className="form-control form-control-user"
                                            onChange={(e) => {
                                              handleInput(
                                                e.target.value,
                                                "mode_of_payment",
                                                e,
                                                "payment_details"
                                              );
                                            }}
                                            required={true}
                                          >
                                            <option value="">
                                              Mode of payment
                                            </option>
                                            <option
                                              value="DD"
                                              selected={
                                                inputList[0]["payment_details"][
                                                  "mode_of_payment"
                                                ] === "DD"
                                              }
                                            >
                                              DD
                                            </option>
                                            <option
                                              value="RTGS"
                                              selected={
                                                inputList[0]["payment_details"][
                                                  "mode_of_payment"
                                                ] === "RTGS"
                                              }
                                            >
                                              RTGS
                                            </option>
                                            <option
                                              value="NEFT"
                                              selected={
                                                inputList[0]["payment_details"][
                                                  "mode_of_payment"
                                                ] === "NEFT"
                                              }
                                            >
                                              NEFT
                                            </option>
                                            <option
                                              value="Other"
                                              selected={
                                                inputList[0]["payment_details"][
                                                  "mode_of_payment"
                                                ] === "Other"
                                              }
                                            >
                                              Other
                                            </option>
                                          </select>
                                          <label className="large-label float-lb">
                                            Mode of payment for Loan Closure{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </label>
                                        </div>
                                      )}
                                      {inputList[0]["payment_details"][
                                        "prev_loan_closure"
                                      ] === "Bank" && (
                                        <div className="col-sm-12 float-field mt-3 mb-2">
                                          <FileUpload
                                            id={`loan_closure_payment_proof`}
                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                            documentUploadUrl={
                                              documentUploadUrlPublic
                                            }
                                            documentUrlData={
                                              documentUrlDataPublic
                                            }
                                            onChange={(val) => {
                                              handleInput(
                                                val,
                                                "loan_closure_payment_proof",
                                                "",
                                                "payment_details"
                                              );
                                            }}
                                            required={true}
                                            prefilledFilename={
                                              inputList[0]["payment_details"][
                                                "loan_closure_payment_proof"
                                              ] ||
                                              ucdCaseByIdResponse?.data
                                                ?.loan_closure_payment_proof
                                                ? "Loan Closure Amount Proof"
                                                : ""
                                            }
                                          >
                                            Loan Closure Amount Proof{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </FileUpload>
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {/*<div*/}
                                  {/*    className="col-sm-6 col-md-3 mt-1 float-field">*/}
                                  {/*    <input type="date"*/}
                                  {/*           className="form-control form-control-user"*/}
                                  {/*           placeholder=" "*/}
                                  {/*           onChange={(e) => {*/}
                                  {/*               handleInput(e.target.value, 'disbursal_date', '', 'payment_details')*/}
                                  {/*           }}*/}
                                  {/*           value={inputList[0]['payment_details']['disbursal_date']}*/}
                                  {/*           required={true}*/}
                                  {/*    />*/}
                                  {/*    <label*/}
                                  {/*        className="large-label float-lb">*/}
                                  {/*        Disbursal Date <i*/}
                                  {/*        className="bi bi-asterisk astrick-icon"></i>*/}
                                  {/*    </label>*/}
                                  {/*</div>*/}
                                  {/*<div*/}
                                  {/*    className="col-sm-6 float-field mb-3">*/}
                                  {/*    <FileUpload*/}
                                  {/*        id={`disbursal_memo`}*/}
                                  {/*        accept=".png,.jpg,.jpeg,.pdf,.doc"*/}
                                  {/*        documentUploadUrl={documentUploadUrlPublic}*/}
                                  {/*        documentUrlData={documentUrlDataPublic}*/}
                                  {/*        onChange={(val) => {*/}
                                  {/*            handleInput(val, 'disbursal_memo', '', 'payment_details')*/}
                                  {/*        }}*/}
                                  {/*        required={true}*/}
                                  {/*        prefilledFilename={inputList[0]['payment_details']['disbursal_memo'] ? "Disbursal Memo" : ""}*/}
                                  {/*    >*/}
                                  {/*        Disbursal Memo <i*/}
                                  {/*        className="bi bi-asterisk astrick-icon"></i>*/}
                                  {/*    </FileUpload>*/}
                                  {/*</div>*/}
                                  <div className="col-sm-12 col-md-12 float-field mt-3 mb-2">
                                    <div className="row">
                                      <div className="col-md-12">
                                        <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                          {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                        </div>
                                        <div className="mb-4 bg-white">
                                          {" "}
                                          {/*card*/}
                                          <div className=" card-header bg-lightGreen-active">
                                            Tranches
                                          </div>
                                          <div className="card-body">
                                            <div className="">
                                              <div className="form-group row">
                                                {bankAmountLoanReceived.map(
                                                  (val, i) => {
                                                    return (
                                                      <>
                                                        {ucdCaseByIdResponse
                                                          ?.data?.status ==
                                                        "REQUEST_FOR_PAYMENT_MODIFICATION" ? (
                                                          <>
                                                            <div className="col-sm-6 col-md-6 mt-1 float-field">
                                                              <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  const value =
                                                                    e.target.value
                                                                      .replace(
                                                                        /[^0-9.]/g,
                                                                        ""
                                                                      ) // Remove non-numeric and non-decimal characters
                                                                      .replace(
                                                                        /^(\.)/,
                                                                        ""
                                                                      ) // Prevent leading decimal points
                                                                      .replace(
                                                                        /(\..*?)\..*/g,
                                                                        "$1"
                                                                      ); // Remove non-numeric characters
                                                                  handleAmountReceivedFromBankInput(
                                                                    value,
                                                                    "loan_amount_received_from_bank",
                                                                    i
                                                                  );
                                                                  e.target.value =
                                                                    value;
                                                                }}
                                                                required={
                                                                  inputList[0][
                                                                    "payment_details"
                                                                  ][
                                                                    "prev_loan_closure"
                                                                  ] === "Bank"
                                                                }
                                                                value={
                                                                  val[
                                                                    "loan_amount_received_from_bank"
                                                                  ]
                                                                }
                                                                step="any" // Allows decimal input
                                                                inputMode="decimal"
                                                                // disabled={amountReceivedEdit[i]}
                                                              />
                                                              <label className="large-label float-lb">
                                                                Loan Amount
                                                                Received From
                                                                Bank
                                                                {inputList[0][
                                                                  "payment_details"
                                                                ][
                                                                  "prev_loan_closure"
                                                                ] ===
                                                                  "Bank" && (
                                                                  <i className="bi bi-asterisk astrick-icon"></i>
                                                                )}
                                                              </label>
                                                            </div>
                                                            <div className="col-sm-6 col-md-6 mt-1 float-field">
                                                              <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  handleAmountReceivedFromBankInput(
                                                                    e.target
                                                                      .value,
                                                                    "bank_transfer_utr_number",
                                                                    i
                                                                  );
                                                                }}
                                                                value={
                                                                  val[
                                                                    "bank_transfer_utr_number"
                                                                  ]
                                                                }
                                                                // disabled={
                                                                //   amountReceivedEdit[
                                                                //     i
                                                                //   ]
                                                                // }
                                                                required={
                                                                  inputList[0][
                                                                    "payment_details"
                                                                  ][
                                                                    "prev_loan_closure"
                                                                  ] === "Bank"
                                                                }
                                                              />
                                                              <label className="large-label float-lb">
                                                                UTR Number
                                                                {inputList[0][
                                                                  "payment_details"
                                                                ][
                                                                  "prev_loan_closure"
                                                                ] ===
                                                                  "Bank" && (
                                                                  <i className="bi bi-asterisk astrick-icon"></i>
                                                                )}
                                                              </label>
                                                            </div>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <div className="col-sm-6 col-md-6 mt-1 float-field">
                                                              <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  const value =
                                                                    e.target.value
                                                                      .replace(
                                                                        /[^0-9.]/g,
                                                                        ""
                                                                      ) // Remove non-numeric and non-decimal characters
                                                                      .replace(
                                                                        /^(\.)/,
                                                                        ""
                                                                      ) // Prevent leading decimal points
                                                                      .replace(
                                                                        /(\..*?)\..*/g,
                                                                        "$1"
                                                                      ); // Remove non-numeric characters
                                                                  handleAmountReceivedFromBankInput(
                                                                    value,
                                                                    "loan_amount_received_from_bank",
                                                                    i
                                                                  );
                                                                  e.target.value =
                                                                    value;
                                                                }}
                                                                required={
                                                                  inputList[0][
                                                                    "payment_details"
                                                                  ][
                                                                    "prev_loan_closure"
                                                                  ] === "Bank"
                                                                }
                                                                value={
                                                                  val[
                                                                    "loan_amount_received_from_bank"
                                                                  ]
                                                                }
                                                                step="any" // Allows decimal input
                                                                inputMode="decimal"
                                                                disabled={
                                                                  amountReceivedEdit[
                                                                    i
                                                                  ]
                                                                }
                                                              />
                                                              <label className="large-label float-lb">
                                                                Loan Amount
                                                                Received From
                                                                Bank
                                                                {inputList[0][
                                                                  "payment_details"
                                                                ][
                                                                  "prev_loan_closure"
                                                                ] ===
                                                                  "Bank" && (
                                                                  <i className="bi bi-asterisk astrick-icon"></i>
                                                                )}
                                                              </label>
                                                            </div>
                                                            <div className="col-sm-6 col-md-6 mt-1 float-field">
                                                              <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  handleAmountReceivedFromBankInput(
                                                                    e.target
                                                                      .value,
                                                                    "bank_transfer_utr_number",
                                                                    i
                                                                  );
                                                                }}
                                                                value={
                                                                  val[
                                                                    "bank_transfer_utr_number"
                                                                  ]
                                                                }
                                                                disabled={
                                                                  amountReceivedEdit[
                                                                    i
                                                                  ]
                                                                }
                                                                required={
                                                                  inputList[0][
                                                                    "payment_details"
                                                                  ][
                                                                    "prev_loan_closure"
                                                                  ] === "Bank"
                                                                }
                                                              />
                                                              <label className="large-label float-lb">
                                                                UTR Number
                                                                {inputList[0][
                                                                  "payment_details"
                                                                ][
                                                                  "prev_loan_closure"
                                                                ] ===
                                                                  "Bank" && (
                                                                  <i className="bi bi-asterisk astrick-icon"></i>
                                                                )}
                                                              </label>
                                                            </div>
                                                          </>
                                                        )}

                                                        <div className="col-md-12 mb-4">
                                                          {bankAmountLoanReceived.length !==
                                                            1 &&
                                                            !amountReceivedEdit[
                                                              i
                                                            ] && (
                                                              <button
                                                                onClick={(e) =>
                                                                  handleRemoveAmountReceivedFromBank(
                                                                    e,
                                                                    i
                                                                  )
                                                                }
                                                                className="btn btn-sm btn-danger"
                                                              >
                                                                Remove Tranche
                                                              </button>
                                                            )}
                                                          {bankAmountLoanReceived.length -
                                                            1 ===
                                                            i && (
                                                            <button
                                                              className="btn btn-sm btn-primary mt-1"
                                                              onClick={(e) =>
                                                                handleAddAmountReceivedFromBank(
                                                                  e
                                                                )
                                                              }
                                                            >
                                                              Add Another
                                                              Tranche
                                                            </button>
                                                          )}
                                                        </div>
                                                      </>
                                                    );
                                                  }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {stage === 2 && (
                    <>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                          </div>
                          <div className="mb-4 bg-white">
                            {" "}
                            {/*card*/}
                            <div className="hide card-header bg-lightGreen-active">
                              Dealer Details
                            </div>
                            <div className="card-body">
                              <div className="user">
                                <div className="form-group row">
                                  <div className="col-sm-6 col-md-6 mt-1 float-field">
                                    <input
                                      type="number"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          e.target.value,
                                          "account_number",
                                          e,
                                          "dealer_details"
                                        );
                                      }}
                                      disabled={true}
                                      value={
                                        loanAccountResponse?.DEALER
                                          ?.account_number
                                      }
                                      required
                                    />
                                    <label className="large-label float-lb">
                                      Account Number{" "}
                                      <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div className="col-sm-6 col-md-6 mt-1 float-field">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          e.target.value,
                                          "bank_name",
                                          e,
                                          "dealer_details"
                                        );
                                      }}
                                      disabled={true}
                                      value={
                                        loanAccountResponse?.DEALER?.bank_name
                                      }
                                      required
                                    />
                                    {/* <select
                                                                            className="form-control form-control-user"
                                                                            onChange={(e) => {
                                                                                handleInput(e.target.value, 'bank_name', e, 'dealer_details')

                                                                            }} required disabled={true}>
                                                                            <option value="">Bank Name
                                                                            </option>
                                                                            {bankListResponse.map(val => {
                                                                                return (
                                                                                    <>
                                                                                        <option
                                                                                            value={val?.name}
                                                                                            selected={loanAccountResponse?.DEALER?.bank_name === val?.id}>{val?.id}</option>
                                                                                    </>
                                                                                )
                                                                            })}

                                                                        </select> */}
                                    <label className="large-label float-lb">
                                      Bank Name{" "}
                                      <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div className="col-sm-6 col-md-6 mt-1 float-field">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          e.target.value,
                                          "ifsc_code",
                                          e,
                                          "dealer_details"
                                        );
                                      }}
                                      required
                                      disabled={true}
                                      value={
                                        loanAccountResponse?.DEALER?.ifsc_code
                                      }
                                    />
                                    <label className="large-label float-lb">
                                      IFSC Code{" "}
                                      <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div className="col-sm-6 col-md-6 mt-1 float-field">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          e.target.value,
                                          "branch_name",
                                          e,
                                          "dealer_details"
                                        );
                                      }}
                                      required
                                      disabled={true}
                                      value={
                                        loanAccountResponse?.DEALER?.branch_name
                                      }
                                    />
                                    <label className="large-label float-lb">
                                      Branch Name{" "}
                                      <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {stage === 3 && (
                    <>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                          </div>
                          <div className="mb-4 bg-white">
                            {" "}
                            {/*card*/}
                            <div className="hide card-header bg-lightGreen-active">
                              Hold Back Amount
                            </div>
                            <div className="card-body">
                              <div className="user">
                                <div className="form-group row">
                                  <div
                                    className={`col-sm-12 col-md-12 ${
                                      inputList[0]["hold_back_Details"][
                                        "amount_approval_proof"
                                      ]
                                        ? "mt-2"
                                        : "mt-4"
                                    } float-field`}
                                  >
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        const value = e.target.value
                                          .replace(/[^0-9.]/g, "") // Remove non-numeric and non-decimal characters
                                          .replace(/^(\.)/, "") // Prevent leading decimal points
                                          .replace(/(\..*?)\..*/g, "$1"); // Remove non-numeric characters
                                        handleInput(
                                          value,
                                          "amount",
                                          e,
                                          "hold_back_Details"
                                        );
                                        e.target.value = value;
                                      }}
                                      required
                                      value={
                                        inputList[0]["hold_back_Details"][
                                          "amount"
                                        ]
                                      }
                                      disabled={
                                        inputList[0]["hold_back_Details"]
                                          ?.status === "DISBURSED"
                                      }
                                      // step="any"      // Allows decimal input
                                      // inputMode="decimal"
                                    />
                                    <label className="large-label float-lb">
                                      Hold back amt is inclusive of RTO and
                                      challan charges{" "}
                                      <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>

                                  <div className="col-sm-12 col-md-12 float-field mb-3">
                                    <FileUpload
                                      id={`amount_approval_proof`}
                                      accept=".png,.jpg,.jpeg,.pdf,.doc"
                                      documentUploadUrl={
                                        documentUploadUrlPublic
                                      }
                                      documentUrlData={documentUrlDataPublic}
                                      onChange={(val) => {
                                        handleInput(
                                          val,
                                          "amount_approval_proof",
                                          "",
                                          "hold_back_Details"
                                        );
                                      }}
                                      required={true}
                                      prefilledFilename={
                                        inputList[0]["hold_back_Details"][
                                          "amount_approval_proof"
                                        ] ||
                                        ucdCaseByIdResponse?.data
                                          ?.hold_back_amount_proof
                                          ? "Hold Back Amount Approval"
                                          : ""
                                      }
                                    >
                                      Amount approval document
                                      {inputList[0]["hold_back_Details"][
                                        "amount"
                                      ] !== amountReceived && (
                                        <i className="bi bi-asterisk astrick-icon"></i>
                                      )}
                                    </FileUpload>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-12 mb-2">
                                    <div
                                      className="card-header "
                                      style={{
                                        "background-color": "rgb(71, 51, 129)",
                                        color: "white",
                                      }}
                                    >
                                      Hold Back Amount Release Tranches
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="user">
                                      <div className="form-group row">
                                        <div
                                          className="col-sm-6 col-md-6 mt-1 float-field"
                                          style={{
                                            marginTop: "16px !important",
                                          }}
                                        >
                                          <select
                                            className="form-control form-control-user"
                                            onChange={(e) => {
                                              handleInput(
                                                e.target.value,
                                                "account_id",
                                                "",
                                                "hold_back_Details"
                                              );
                                            }}
                                            required
                                            disabled={
                                              inputList[0]["hold_back_Details"]
                                                ?.status === "DISBURSED"
                                            }
                                          >
                                            <option value="">
                                              Select Account
                                            </option>
                                            {loanAccountResponse?.accounts &&
                                              loanAccountResponse?.accounts.map(
                                                (val) => {
                                                  return (
                                                    <>
                                                      <option
                                                        value={val?.id}
                                                        selected={
                                                          parseInt(
                                                            loanTranchesResponse
                                                              ?.data
                                                              ?.HOLD_BACK_TRANCHE[0]
                                                              ?.account_id
                                                          ) ===
                                                          parseInt(val?.id)
                                                        }
                                                      >
                                                        {val?.name}
                                                      </option>
                                                    </>
                                                  );
                                                }
                                              )}
                                          </select>
                                          <label className="large-label float-lb">
                                            Account{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </label>
                                        </div>
                                        <div
                                          className="col-sm-6 col-md-6 mt-1 float-field"
                                          style={{
                                            marginTop: "16px !important",
                                          }}
                                        >
                                          <select
                                            className="form-control form-control-user"
                                            onChange={(e) => {
                                              handleInput(
                                                e.target.value,
                                                "mode_of_payment",
                                                "",
                                                "hold_back_Details"
                                              );
                                            }}
                                            required
                                            disabled={
                                              inputList[0]["hold_back_Details"]
                                                ?.status === "DISBURSED"
                                            }
                                          >
                                            <option value="">
                                              {" "}
                                              Select Mode of payment
                                            </option>
                                            <option
                                              value="DD"
                                              selected={
                                                loanTranchesResponse?.data
                                                  ?.HOLD_BACK_TRANCHE[0]
                                                  ?.payment_mode === "DD"
                                              }
                                            >
                                              DD
                                            </option>
                                            <option
                                              value="RTGS"
                                              selected={
                                                loanTranchesResponse?.data
                                                  ?.HOLD_BACK_TRANCHE[0]
                                                  ?.payment_mode === "RTGS"
                                              }
                                            >
                                              RTGS
                                            </option>
                                            <option
                                              value="NEFT"
                                              selected={
                                                loanTranchesResponse?.data
                                                  ?.HOLD_BACK_TRANCHE[0]
                                                  ?.payment_mode === "NEFT"
                                              }
                                            >
                                              NEFT
                                            </option>
                                            <option
                                              value="Other"
                                              selected={
                                                loanTranchesResponse?.data
                                                  ?.HOLD_BACK_TRANCHE[0]
                                                  ?.payment_mode === "Other"
                                              }
                                            >
                                              Other
                                            </option>
                                          </select>
                                          <label className="large-label float-lb">
                                            Mode of payment{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </label>
                                        </div>
                                        <div className="col-sm-6 col-md-6 mt-3 float-field">
                                          <input
                                            type="text"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              handleInput(
                                                e.target.value,
                                                "remark",
                                                "",
                                                "hold_back_Details"
                                              );
                                            }}
                                            required
                                            value={
                                              inputList[0]["hold_back_Details"][
                                                "remark"
                                              ]
                                            }
                                            disabled={
                                              inputList[0]["hold_back_Details"]
                                                ?.status === "DISBURSED"
                                            }
                                          />
                                          <label className="large-label float-lb">
                                            Remark{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </label>
                                        </div>
                                        {inputList[0]["hold_back_Details"]
                                          ?.status === "DISBURSED" && (
                                          <div className="col-sm-6 col-md-6 mt-1 float-field">
                                            <input
                                              type="text"
                                              className="form-control form-control-user"
                                              placeholder=" "
                                              required
                                              value={
                                                inputList[0][
                                                  "hold_back_Details"
                                                ]?.utr_number
                                              }
                                              disabled={true}
                                            />
                                            <label className="large-label float-lb">
                                              UTR Number{" "}
                                              <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {stage === 4 && (
                    <>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                          </div>
                          <div className="mb-4 bg-white">
                            {" "}
                            {/*card*/}
                            <div className="hide card-header bg-lightGreen-active">
                              Tranches
                            </div>
                            <div className="card-body">
                              <div className="user">
                                <div className="form-group row">
                                  {tranches.map((val, i) => {
                                    return (
                                      <>
                                        <div className="col-sm-6 col-md-6 mt-1 float-field">
                                          <input
                                            type="text"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              const value = e.target.value
                                                .replace(/[^0-9.]/g, "") // Remove non-numeric and non-decimal characters
                                                .replace(/^(\.)/, "") // Prevent leading decimal points
                                                .replace(/(\..*?)\..*/g, "$1"); // Remove non-numeric characters
                                              handleTrancheInput(
                                                value,
                                                "amount",
                                                i
                                              );
                                              e.target.value = value;
                                            }}
                                            // required
                                            value={val["amount"]}
                                            // step="any"      // Allows decimal input
                                            // inputMode="decimal"
                                            disabled={
                                              val?.status === "DISBURSED"
                                            }
                                          />
                                          <label className="large-label float-lb">
                                            Tranche Amount
                                            {/*<i*/}
                                            {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                          </label>
                                        </div>
                                        <div
                                          className="col-sm-6 mt-1 float-field"
                                          style={{
                                            marginTop: "16px !important",
                                          }}
                                        >
                                          <select
                                            className="form-control form-control-user"
                                            onChange={(e) => {
                                              handleTrancheInput(
                                                e.target.value,
                                                "account_id",
                                                i
                                              );
                                            }}
                                            disabled={
                                              val?.status === "DISBURSED"
                                            }
                                          >
                                            <option value="">
                                              Select Account
                                            </option>
                                            {loanAccountResponse?.accounts &&
                                              loanAccountResponse?.accounts.map(
                                                (value) => {
                                                  return (
                                                    <>
                                                      <option
                                                        value={value?.id}
                                                        selected={
                                                          parseInt(
                                                            val?.account_id
                                                          ) ===
                                                          parseInt(value?.id)
                                                        }
                                                      >
                                                        {value?.name}
                                                      </option>
                                                    </>
                                                  );
                                                }
                                              )}
                                          </select>
                                          <label className="large-label float-lb">
                                            Account
                                            {/*<i*/}
                                            {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                          </label>
                                        </div>
                                        <div
                                          className="col-sm-6 col-md-6 mt-1 float-field"
                                          style={{
                                            marginTop: "16px !important",
                                          }}
                                        >
                                          <select
                                            className="form-control form-control-user"
                                            onChange={(e) => {
                                              handleTrancheInput(
                                                e.target.value,
                                                "payment_mode",
                                                i
                                              );
                                            }}
                                            disabled={
                                              val?.status === "DISBURSED"
                                            }
                                          >
                                            <option value="">
                                              Select Mode of payment
                                            </option>
                                            <option
                                              value="DD"
                                              selected={
                                                val["payment_mode"] === "DD"
                                              }
                                            >
                                              DD
                                            </option>
                                            <option
                                              value="RTGS"
                                              selected={
                                                val["payment_mode"] === "RTGS"
                                              }
                                            >
                                              RTGS
                                            </option>
                                            <option
                                              value="NEFT"
                                              selected={
                                                val["payment_mode"] === "NEFT"
                                              }
                                            >
                                              NEFT
                                            </option>
                                            <option
                                              value="Other"
                                              selected={
                                                val["payment_mode"] === "Other"
                                              }
                                            >
                                              Other
                                            </option>
                                          </select>
                                          <label className="large-label float-lb">
                                            Mode of payment
                                            {/*<i*/}
                                            {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                          </label>
                                        </div>
                                        <div className="col-sm-6 col-md-6 mt-1 float-field">
                                          <input
                                            type="text"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              handleTrancheInput(
                                                e.target.value,
                                                "remark",
                                                i
                                              );
                                            }}
                                            // required
                                            value={val?.remark}
                                            disabled={
                                              val?.status === "DISBURSED"
                                            }
                                          />
                                          <label className="large-label float-lb">
                                            Remark
                                            {/*<i*/}
                                            {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                          </label>
                                        </div>
                                        {val?.status === "DISBURSED" && (
                                          <div className="col-sm-6 col-md-6 mt-1 float-field">
                                            <input
                                              type="text"
                                              className="form-control form-control-user"
                                              placeholder=" "
                                              required
                                              value={val?.utr_number}
                                              disabled={
                                                val?.status === "DISBURSED"
                                              }
                                            />
                                            <label className="large-label float-lb">
                                              UTR Number{" "}
                                              <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                          </div>
                                        )}
                                        <div
                                          className="col-md-12 mb-4"
                                        >
                                          {tranches.length !== 1 && (
                                            <button
                                              onClick={(e) =>
                                                handleRemoveTranches(e, i)
                                              }
                                              className="btn btn-sm btn-danger"
                                            >
                                              Remove Tranche
                                            </button>
                                          )}
                                          {tranches.length - 1 === i && (
                                            <button
                                              className="btn btn-sm btn-primary mt-1"
                                              onClick={(e) =>
                                                handleAddTranches(e)
                                              }
                                            >
                                              Add Another Tranche
                                            </button>
                                          )}
                                        </div>
                                      </>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {stage === 5 && (
                    <>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                          </div>
                          <div className="mb-4 bg-white">
                            {" "}
                            {/*card*/}
                            <div className="hide card-header bg-lightGreen-active">
                              Undertaking
                            </div>
                            <div className="card-body">
                              <div className="user">
                                <div className="form-group row">
                                  <div className="col-sm-6 float-field mb-3">
                                    <FileUpload
                                      id={`undertaking`}
                                      accept=".png,.jpg,.jpeg,.pdf,.doc"
                                      documentUploadUrl={
                                        documentUploadUrlPublic
                                      }
                                      documentUrlData={documentUrlDataPublic}
                                      onChange={(val) => {
                                        handleInput(
                                          val,
                                          "undertaking",
                                          "",
                                          "undertaking"
                                        );
                                      }}
                                      required={true}
                                      prefilledFilename={
                                        inputList[0]["undertaking"][
                                          "undertaking"
                                        ] ||
                                        ucdCaseByIdResponse?.data
                                          ?.customer_undertaking
                                          ? "Undertaking"
                                          : ""
                                      }
                                    >
                                      Undertaking
                                    </FileUpload>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="d-flex" style={{justifyContent: "space-between"}}>
                    {parseInt(stage) > 1 && (
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary btn-user btn-block submit-btn-payment"
                          onClick={(e) => {
                            handleStage(stage - 1);
                          }}
                        >
                          Go Back
                        </button>
                      </div>
                    )}

                    {parseInt(stage) <= 4 && (
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary btn-user btn-block submit-btn-payment"
                          onClick={(e) => {
                            handleStage(stage + 1);
                          }}
                        >
                          Next
                        </button>
                      </div>
                    )}

                    {parseInt(stage) === 5 && (
                      <div className="col-md-2">
                        <button className="btn btn-primary btn-user btn-block submit-btn-payment">
                          Submit
                        </button>
                      </div>
                    )}
                  </div>
                </form>

                {ucdCaseByIdResponse?.data &&
                  ucdCaseByIdResponse?.data?.status !== "APPROVED" && (
                    <div className="col-md-2 mt-4">
                      <button
                        className="btn btn-primary btn-user btn-block submit-btn-payment"
                        onClick={handlePaymentRelease}
                      >
                        Request For Payment Release
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <BottomMenu />
      </div>
    </>
  );
};

export default RaisePaymentV2;
